const FEATURED = {
  tag: "今日头条",
  title: "一周热门现场回顾：周末人流峰值 引发现场服务大考",
  excerpt:
    "多地大型活动周末扎堆举行，人气持续走高。从入口动线、便民服务到应急通道，本期头条带你看懂现场人气背后的秩序账与体验账。",
  meta: "编辑部 · 现场组",
  time: "今天 09:40",
  minutes: 8,
  image:
    "https://readdy.ai/api/search-image?query=wide%20evening%20shot%20of%20a%20crowded%20city%20venue%20entrance%20with%20warm%20lantern%20lighting%20and%20people%20queuing%20in%20an%20orderly%20flow%2C%20editorial%20magazine%20photography%2C%20warm%20amber%20and%20coral%20tones%2C%20rich%20atmospheric%20detail&width=1200&height=700&seq=hero-feat&orientation=landscape",
};

const SUBS = [
  { no: "01", tag: "综艺", title: "老牌亲子综艺重启，阵容一官宣就炸出满屏讨论", heat: "865万" },
  { no: "02", tag: "生活", title: "博主镜头里的小城夜市，看得网友连夜定了火车票", heat: "704万" },
  { no: "03", tag: "现场", title: "音乐节加场扩容，主办方：把人先安顿好再说", heat: "612万" },
];

const PILLS = [
  { tag: "热梗", text: "一句台词出圈，全网开始打卡接龙" },
  { tag: "体育", text: "业余球队连续三场加时，门将封神" },
  { tag: "科技", text: "开源项目破十万星，新手教程秒懂版上线" },
  { tag: "演出", text: "话剧巡演首站售罄，官方宣布加场" },
];

export default function Hero() {
  return (
    <section id="top" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        {/* 首屏标题区 */}
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-sun-line" aria-hidden="true" />
              每天 3 分钟，看懂今天全网在聊什么
            </p>
            <h1 className="font-heading text-3xl font-black leading-snug text-foreground-950 md:text-[40px] md:leading-tight">
              吃瓜不迷路，<span className="text-primary-500">大事早知道</span>
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              瓜田日报把碎片化的短视频热点，按「热榜排行 → 突发跟进 → 深度复盘」三层重新整理，省去你到处拼信息的功夫。
            </p>
          </div>
          <a
            href="#hot"
            className="group inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:self-auto"
          >
            去今日热榜
            <i className="ri-arrow-right-down-line transition-transform group-hover:translate-y-0.5" aria-hidden="true" />
          </a>
        </div>

        {/* 编辑推荐 + 侧栏 */}
        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group lg:col-span-7">
            <a href="#review" className="block overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={FEATURED.image}
                  alt="周末大型活动现场人流与灯光"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  {FEATURED.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {FEATURED.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{FEATURED.excerpt}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-3-line" aria-hidden="true" />
                    {FEATURED.meta}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line" aria-hidden="true" />
                    {FEATURED.time}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-book-open-line" aria-hidden="true" />
                    约 {FEATURED.minutes} 分钟读完
                  </span>
                </div>
              </div>
            </a>
          </article>

          {/* 侧栏今日在聊 */}
          <aside className="lg:col-span-5" aria-label="今日在聊">
            <div className="flex items-center justify-between border-b border-background-200 pb-3">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
                <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
                今日在聊
              </h3>
              <a href="#hot" className="text-xs text-foreground-500 hover:text-primary-600">
                查看热榜
              </a>
            </div>
            <ul className="divide-y divide-background-100">
              {SUBS.map((s) => (
                <li key={s.no}>
                  <a href="#hot" className="group flex items-start gap-4 py-4">
                    <span className="font-heading text-2xl font-black leading-none text-background-300 transition-colors group-hover:text-primary-400">
                      {s.no}
                    </span>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="rounded bg-background-100 px-1.5 py-0.5 text-xs text-foreground-500">{s.tag}</span>
                        <span className="text-xs text-foreground-400">{s.heat} 热度</span>
                      </div>
                      <p className="mt-1.5 line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                        {s.title}
                      </p>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </aside>
        </div>

        {/* 一句话热点 */}
        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {PILLS.map((p) => (
            <div key={p.text} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-discuss-line" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <span className="text-xs text-foreground-400">{p.tag}</span>
                <p className="truncate text-sm text-foreground-800">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}